import { render, staticRenderFns } from "./transportationSettlementManagement.vue?vue&type=template&id=3f96402d&scoped=true"
import script from "./transportationSettlementManagement.vue?vue&type=script&lang=js"
export * from "./transportationSettlementManagement.vue?vue&type=script&lang=js"
import style0 from "./transportationSettlementManagement.vue?vue&type=style&index=0&id=3f96402d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96402d",
  null
  
)

export default component.exports